import React, { useEffect, useRef, useState } from "react";

import { Link, useLocation, useParams } from "react-router-dom";

import { useSelector } from "react-redux";

import apiCustom from "../../utils/ApiCustom";

import BusinessForm from "../../components/client/BusinessForm";

import QRCode from "react-qr-code";

import EventPDFModal from "../../components/admin/EventPDFModal";

import {
  ArrowDownTrayIcon,
  CheckCircleIcon,
  HomeIcon,
  QrCodeIcon,
  UserPlusIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

import { formatDate } from "../../utils/helps";

import { toast } from "react-toastify";

const ASSOCIATION_NAME = "Hội xây dựng TP. Cần Thơ CCA";

const getDateOnlyTime = (value) => {
  const date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
};

const DetailNoti = () => {
  const { slug1 } = useParams();

  const { search } = useLocation();

  const guestRegisCode = new URLSearchParams(search).get("code");

  const guestQrRef = useRef(null);

  const guestQrAutoDownloadedRef = useRef(false);

  const [article, setArticle] = useState(null);

  const [loading, setLoading] = useState(true);

  const [guestLoading, setGuestLoading] = useState(false);

  const [error, setError] = useState(null);

  const [comments, setComments] = useState([]);

  const [newComment, setNewComment] = useState("");

  const [commentLoading, setCommentLoading] = useState(false);

  const posts = useSelector((state) => state.posts.posts);

  const logo = useSelector((state) => state.logo.logo);

  const [isRegistedEvent, setIsRegistedEvent] = useState(false);

  const [regisRollCallQRcode, setregisRollCallQRcode] = useState(null);

  const userId = localStorage.getItem("userId");

  const userEmail = localStorage.getItem("userEmail");

  const [isOpenPdf, setIsOpenPdf] = useState(false);

  const [eventData, setEventData] = useState(null);

  const [postData, setPostData] = useState(null);

  const [isOpenGuestRegis, setIsOpenGuestRegis] = useState(false);

  const [guestRegisSuccess, setGuestRegisSuccess] = useState(false);

  const [guestFormData, setGuestFormData] = useState({
    fullName: "",
    organizationName: "",
    businessAddress: "",
    businessField: "",
    email: "",
    phoneNumber: "",
  });

  const [guestErrors, setGuestErrors] = useState({});

  const handleOpenPdf = () => {
    setIsOpenPdf(true);
  };

  const getEventData = async () => {
    if (!postData?.id) return;

    try {
      const response = await apiCustom.get(
        `/event-show-by-post-id/${postData.id}`,
      );

      setEventData(response.data.data[0]);
    } catch (err) {
      console.error("Failed to fetch event data:", err);
    }
  };

  useEffect(() => {
    if (postData) {
      getEventData();
    }
  }, [postData]);

  const handleClosePdf = () => {
    setIsOpenPdf(false);
  };

  const handleOpenGuestRegis = () => {
    guestQrAutoDownloadedRef.current = false;

    setGuestRegisSuccess(false);

    setGuestErrors({});

    setIsOpenGuestRegis(true);
  };

  const handleCloseGuestRegis = () => {
    setIsOpenGuestRegis(false);

    setGuestRegisSuccess(false);
  };

  useEffect(() => {
    if (!isOpenGuestRegis) return;

    const scrollY = window.scrollY;

    const originalBodyOverflow = document.body.style.overflow;

    const originalBodyPosition = document.body.style.position;

    const originalBodyTop = document.body.style.top;

    const originalBodyWidth = document.body.style.width;

    const originalHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = "hidden";

    document.body.style.position = "fixed";

    document.body.style.top = `-${scrollY}px`;

    document.body.style.width = "100%";

    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalBodyOverflow;

      document.body.style.position = originalBodyPosition;

      document.body.style.top = originalBodyTop;

      document.body.style.width = originalBodyWidth;

      document.documentElement.style.overflow = originalHtmlOverflow;

      window.scrollTo(0, scrollY);
    };
  }, [isOpenGuestRegis]);

  const dataUrlToBlob = (dataUrl) => {
    const arr = dataUrl.split(",");

    const mime = arr[0].match(/:(.*?);/)?.[1] || "image/png";

    const bstr = atob(arr[1]);

    let n = bstr.length;

    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  };

  const handleGuestChange = (e) => {
    const { name, value } = e.target;

    setGuestFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setGuestErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateGuestForm = () => {
    const errors = {};

    if (!guestFormData.fullName.trim()) {
      errors.fullName = "Tên không được để trống";
    }

    if (!guestFormData.phoneNumber.trim()) {
      errors.phoneNumber = "Số điện thoại không được để trống";
    }

    setGuestErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleSubmitGuestRegis = async (e) => {
    e.preventDefault();

    if (!validateGuestForm()) return;

    setGuestLoading(true);

    try {
      const res = await apiCustom({
        method: "post",
        url: "eventRegistration-create-guest",
        data: {
          fullName: guestFormData.fullName,
          organizationName: guestFormData.organizationName,
          businessAddress: guestFormData.businessAddress,
          businessField: guestFormData.businessField,
          email: guestFormData.email,
          phoneNumber: guestFormData.phoneNumber,
          postId: article?.id,
          guestRegisCode,
        },
        headers: { "Content-Type": "application/json" },
      });

      guestQrAutoDownloadedRef.current = false;

      setIsRegistedEvent(true);

      setregisRollCallQRcode(res?.data?.data?.rollCallQrCode);

      setGuestRegisSuccess(true);

      toast.success(res?.data?.message || "Đăng ký sự kiện thành công");
    } catch (error) {
      const status = error?.response?.status;

      if (status === 422) {
        const msgMap = error?.response?.data?.messages;

        const firstMsg = msgMap
          ? Object.values(msgMap)[0]
          : "Dữ liệu không hợp lệ";

        toast.error(firstMsg);
      } else {
        toast.error(
          error?.response?.data?.messages ||
            error?.response?.data?.message ||
            "Đăng ký không thành công",
        );
      }
    } finally {
      setGuestLoading(false);
    }
  };

  const isZaloBrowser = () => {
    const ua = (navigator.userAgent || "").toLowerCase();

    return (
      ua.includes("zalo") ||
      ua.includes("zalowebview") ||
      ua.includes("zaloplatform") ||
      ua.includes("zbrowser") ||
      typeof window.ZaloJavaScriptInterface !== "undefined" ||
      typeof window.zaloJSV2 !== "undefined"
    );
  };

  const downloadDataUrlForNormalBrowser = (dataUrl, fileName) => {
    const blob = dataUrlToBlob(dataUrl);

    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = objectUrl;

    link.download = fileName;

    link.target = "_self";

    link.rel = "noopener noreferrer";

    link.style.display = "none";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    setTimeout(() => {
      URL.revokeObjectURL(objectUrl);
    }, 3000);
  };

  const downloadDataUrlForZaloBrowser = (dataUrl, fileName) => {
    const blob = dataUrlToBlob(dataUrl);

    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = objectUrl;

    link.download = fileName;

    link.target = "_self";

    link.rel = "noopener noreferrer";

    link.style.display = "none";

    document.body.appendChild(link);

    try {
      link.click();
    } catch (err) {
      console.error("Zalo link.click failed:", err);
    }

    try {
      const clickEvent = document.createEvent("MouseEvents");

      clickEvent.initMouseEvent(
        "click",
        true,
        true,
        window,
        1,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null,
      );

      link.dispatchEvent(clickEvent);
    } catch (err) {
      console.error("Zalo dispatchEvent failed:", err);
    }

    setTimeout(() => {
      try {
        const secondLink = document.createElement("a");

        secondLink.href = dataUrl;

        secondLink.download = fileName;

        secondLink.target = "_self";

        secondLink.rel = "noopener noreferrer";

        secondLink.style.display = "none";

        document.body.appendChild(secondLink);

        secondLink.click();

        document.body.removeChild(secondLink);
      } catch (err) {
        console.error("Zalo dataUrl click failed:", err);
      }
    }, 250);

    setTimeout(() => {
      if (document.body.contains(link)) {
        document.body.removeChild(link);
      }
    }, 1500);

    setTimeout(() => {
      URL.revokeObjectURL(objectUrl);
    }, 8000);
  };

  const downloadDataUrl = (dataUrl, fileName) => {
    try {
      if (isZaloBrowser()) {
        downloadDataUrlForZaloBrowser(dataUrl, fileName);

        return;
      }

      downloadDataUrlForNormalBrowser(dataUrl, fileName);
    } catch (err) {
      console.error("Failed to download QR:", err);
    }
  };

  const loadCanvasImage = (src) => {
    return new Promise((resolve) => {
      if (!src) {
        resolve(null);

        return;
      }

      const image = new Image();

      image.crossOrigin = "anonymous";

      image.onload = () => {
        resolve(image);
      };

      image.onerror = () => {
        resolve(null);
      };

      image.src = src;
    });
  };

  const handleDownloadGuestQr = (
    closeAfterDownload = false,
    silent = false,
  ) => {
    const svg = guestQrRef.current?.querySelector("svg");

    if (!svg) {
      if (!silent) toast.error("Không tìm thấy mã QR");

      return;
    }

    const clonedSvg = svg.cloneNode(true);

    if (!clonedSvg.getAttribute("xmlns")) {
      clonedSvg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    }

    const svgData = new XMLSerializer().serializeToString(clonedSvg);

    const svgUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
      svgData,
    )}`;

    const image = new Image();

    image.onload = async () => {
      const canvas = document.createElement("canvas");

      const width = 900;

      const height = 1780;

      const ctx = canvas.getContext("2d");

      const logoImage = await loadCanvasImage(logo);

      canvas.width = width;

      canvas.height = height;

      const eventTitle = article?.title || "Sự kiện";

      const eventDate = article?.eventStartTime
        ? formatDate(article.eventStartTime)
        : "";

      const drawRoundRect = (x, y, w, h, radius) => {
        ctx.beginPath();

        ctx.moveTo(x + radius, y);

        ctx.lineTo(x + w - radius, y);

        ctx.quadraticCurveTo(x + w, y, x + w, y + radius);

        ctx.lineTo(x + w, y + h - radius);

        ctx.quadraticCurveTo(x + w, y + h, x + w - radius, y + h);

        ctx.lineTo(x + radius, y + h);

        ctx.quadraticCurveTo(x, y + h, x, y + h - radius);

        ctx.lineTo(x, y + radius);

        ctx.quadraticCurveTo(x, y, x + radius, y);

        ctx.closePath();
      };

      const drawWrappedText = (text, x, y, maxWidth, lineHeight, maxLines) => {
        const words = String(text).split(" ");

        let line = "";

        let lines = [];

        for (let i = 0; i < words.length; i++) {
          const testLine = line + words[i] + " ";

          const metrics = ctx.measureText(testLine);

          if (metrics.width > maxWidth && i > 0) {
            lines.push(line.trim());

            line = words[i] + " ";
          } else {
            line = testLine;
          }
        }

        lines.push(line.trim());

        if (lines.length > maxLines) {
          lines = lines.slice(0, maxLines);

          lines[maxLines - 1] = lines[maxLines - 1] + "...";
        }

        lines.forEach((item, index) => {
          ctx.fillText(item, x, y + index * lineHeight);
        });

        return lines.length * lineHeight;
      };

      const drawCoverImage = (img, x, y, w, h) => {
        const imgRatio = img.width / img.height;

        const boxRatio = w / h;

        let sx = 0;

        let sy = 0;

        let sw = img.width;

        let sh = img.height;

        if (imgRatio > boxRatio) {
          sw = img.height * boxRatio;

          sx = (img.width - sw) / 2;
        } else {
          sh = img.width / boxRatio;

          sy = (img.height - sh) / 2;
        }

        ctx.drawImage(img, sx, sy, sw, sh, x, y, w, h);
      };

      const backgroundGradient = ctx.createLinearGradient(0, 0, 0, height);

      backgroundGradient.addColorStop(0, "#eff6ff");

      backgroundGradient.addColorStop(1, "#ecfeff");

      ctx.fillStyle = backgroundGradient;

      ctx.fillRect(0, 0, width, height);

      ctx.fillStyle = "#ffffff";

      ctx.shadowColor = "rgba(15, 23, 42, 0.18)";

      ctx.shadowBlur = 35;

      ctx.shadowOffsetY = 16;

      drawRoundRect(70, 70, width - 140, height - 140, 36);

      ctx.fill();

      ctx.shadowColor = "transparent";

      ctx.shadowBlur = 0;

      ctx.shadowOffsetY = 0;

      ctx.fillStyle = "#2563eb";

      drawRoundRect(70, 70, width - 140, 195, 36);

      ctx.fill();

      if (logoImage) {
        ctx.save();

        ctx.fillStyle = "#ffffff";

        drawRoundRect(115, 105, 78, 78, 18);

        ctx.fill();

        drawCoverImage(logoImage, 123, 113, 62, 62);

        ctx.restore();
      }

      ctx.fillStyle = "#ffffff";

      ctx.font = "bold 29px Arial";

      ctx.textAlign = "left";

      drawWrappedText(ASSOCIATION_NAME, 220, 126, width - 330, 36, 2);

      ctx.textAlign = "center";

      ctx.font = "bold 34px Arial";

      ctx.fillText("MÃ QR CHECK-IN", width / 2, 210);

      ctx.font = "22px Arial";

      ctx.fillText(
        "Vui lòng xuất trình mã này khi tham gia sự kiện",
        width / 2,
        245,
      );

      ctx.fillStyle = "#111827";

      ctx.font = "bold 34px Arial";

      const titleStartY = 350;

      const titleHeight = drawWrappedText(
        eventTitle,
        width / 2,
        titleStartY,
        width - 220,
        46,
        4,
      );

      let dateY = titleStartY + titleHeight + 28;

      if (eventDate) {
        ctx.fillStyle = "#6b7280";

        ctx.font = "24px Arial";

        ctx.fillText(`Ngày diễn ra: ${eventDate}`, width / 2, dateY);
      }

      const qrBoxSize = 520;

      const qrBoxX = (width - qrBoxSize) / 2;

      const qrBoxY = Math.max(580, dateY + 58);

      ctx.fillStyle = "#f8fafc";

      drawRoundRect(
        qrBoxX - 30,
        qrBoxY - 30,
        qrBoxSize + 60,
        qrBoxSize + 60,
        32,
      );

      ctx.fill();

      ctx.strokeStyle = "#dbeafe";

      ctx.lineWidth = 4;

      drawRoundRect(
        qrBoxX - 30,
        qrBoxY - 30,
        qrBoxSize + 60,
        qrBoxSize + 60,
        32,
      );

      ctx.stroke();

      ctx.fillStyle = "#ffffff";

      ctx.fillRect(qrBoxX, qrBoxY, qrBoxSize, qrBoxSize);

      ctx.drawImage(
        image,
        qrBoxX + 35,
        qrBoxY + 35,
        qrBoxSize - 70,
        qrBoxSize - 70,
      );

      if (logoImage) {
        const logoBoxSize = 104;

        const logoBoxX = qrBoxX + qrBoxSize / 2 - logoBoxSize / 2;

        const logoBoxY = qrBoxY + qrBoxSize / 2 - logoBoxSize / 2;

        ctx.fillStyle = "#ffffff";

        drawRoundRect(logoBoxX, logoBoxY, logoBoxSize, logoBoxSize, 24);

        ctx.fill();

        ctx.strokeStyle = "#e5e7eb";

        ctx.lineWidth = 3;

        drawRoundRect(logoBoxX, logoBoxY, logoBoxSize, logoBoxSize, 24);

        ctx.stroke();

        drawCoverImage(
          logoImage,
          logoBoxX + 14,
          logoBoxY + 14,
          logoBoxSize - 28,
          logoBoxSize - 28,
        );
      }

      const qrBottomY = qrBoxY + qrBoxSize;

      ctx.fillStyle = "#111827";

      ctx.font = "bold 28px Arial";

      ctx.fillText("QR CHECK-IN SỰ KIỆN", width / 2, qrBottomY + 70);

      ctx.fillStyle = "#2563eb";

      ctx.font = "bold 25px Arial";

      drawWrappedText(
        ASSOCIATION_NAME,
        width / 2,
        qrBottomY + 112,
        width - 180,
        34,
        2,
      );

      ctx.fillStyle = "#6b7280";

      ctx.font = "22px Arial";

      ctx.fillText(
        "Vui lòng không chia sẻ mã QR này cho người khác",
        width / 2,
        qrBottomY + 198,
      );

      try {
        const pngDataUrl = canvas.toDataURL("image/png");

        downloadDataUrl(
          pngDataUrl,
          `qr-diem-danh-${article?.slug || "su-kien"}.png`,
        );

        if (closeAfterDownload) {
          handleCloseGuestRegis();
        }
      } catch (err) {
        console.error("Failed to create QR image:", err);

        if (!silent) toast.error("Không thể tải mã QR");
      }
    };

    image.onerror = () => {
      if (!silent) toast.error("Không thể tải mã QR");
    };

    image.src = svgUrl;
  };

  useEffect(() => {
    if (
      isOpenGuestRegis &&
      guestRegisSuccess &&
      regisRollCallQRcode &&
      !guestQrAutoDownloadedRef.current
    ) {
      guestQrAutoDownloadedRef.current = true;

      setTimeout(() => {
        handleDownloadGuestQr(false, true);
      }, 500);
    }
  }, [isOpenGuestRegis, guestRegisSuccess, regisRollCallQRcode]);

  const getGuestRegisTiming = () => {
    const today = getDateOnlyTime(new Date());

    const regisStartTime = article?.regisStartTime
      ? getDateOnlyTime(article.regisStartTime)
      : NaN;

    const regisEndTime = article?.regisEndTime
      ? getDateOnlyTime(article.regisEndTime)
      : NaN;

    if (Number.isFinite(regisStartTime) && today < regisStartTime) {
      return { label: "Chưa đến thời gian đăng ký", lock: true };
    }

    if (Number.isFinite(regisEndTime) && today > regisEndTime) {
      return { label: "Hết hạn đăng ký", lock: true };
    }

    return { label: "Đăng ký tham gia", lock: false };
  };

  useEffect(() => {
    const post = posts
      ?.filter((post) => post.status === "published")
      ?.find((post) => post.slug === slug1);

    setPostData(post);

    window.scrollTo(0, 0);

    const fetchArticle = async () => {
      try {
        if (!post) {
          setError("Post not found");

          setLoading(false);

          return;
        }

        const response = await apiCustom.get(`posts-public/${post.id}`);

        setArticle(response.data.data);

        setComments(response.data.data.comments || []);
      } catch (err) {
        setError(err.message);

        setLoading(false);
      }
    };

    const checkEventRegisted = async () => {
      if (guestRegisCode) {
        setLoading(false);

        return;
      }

      if (!userEmail) {
        setLoading(false);

        return;
      }

      try {
        await apiCustom
          .get(
            `/eventRegistration-check-registed?email=${userEmail}&pid=${post.id}`,
          )
          .then((res) => {
            setIsRegistedEvent(res?.data?.data?.isRegistered);

            setregisRollCallQRcode(res?.data?.rollCallQrCode);
          });

        setLoading(false);
      } catch (err) {
        setError(err.message);

        setLoading(false);
      }
    };

    fetchArticle();

    checkEventRegisted();
  }, [slug1, posts, isRegistedEvent, userEmail, guestRegisCode]);

  const getRegisStatusFromBussinessForm = (isRegisted) => {
    setIsRegistedEvent(isRegisted);
  };

  const handleCommentSubmit = async (e) => {
    e.preventDefault();

    if (!newComment.trim()) return;

    setCommentLoading(true);

    try {
      // Assuming the API returns the newly created comment
      // const createdComment = response.data.data;
      // Update comments list
      // setComments([...comments, createdComment]);
      // Clear the comment input
      // setNewComment("");
    } catch (err) {
      console.error("Failed to submit comment:", err);
    } finally {
      setCommentLoading(false);
    }
  };

  const renderQrWithLogo = (value, size = 256) => (
    <div
      className="relative inline-flex items-center justify-center bg-white"
      style={{ width: size, height: size }}
    >
      <QRCode value={value} size={size} level="H" />

      {logo && (
        <div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-xl bg-white p-1 shadow-sm">
          <img
            src={logo}
            alt="Logo"
            className="h-12 w-12 rounded-lg object-contain"
          />
        </div>
      )}
    </div>
  );

  const isGuestRegisCodeMatched =
    article?.type === "notification" &&
    guestRegisCode &&
    article?.guestRegisCode &&
    String(guestRegisCode) === String(article.guestRegisCode);

  const guestTiming = getGuestRegisTiming();

  useEffect(() => {
    if (
      isGuestRegisCodeMatched &&
      !guestTiming.lock &&
      !isRegistedEvent &&
      !guestRegisSuccess
    ) {
      handleOpenGuestRegis();
    }
  }, [
    isGuestRegisCodeMatched,
    guestTiming.lock,
    isRegistedEvent,
    guestRegisSuccess,
  ]);

  if (loading) {
    return <div className="container mx-auto px-4">Loading...</div>;
  }

  if (error) {
    return <div className="container mx-auto px-4">Error: {error}</div>;
  }

  return (
    <div className="container mx-auto px-4">
      <nav className="flex text-gray-500 text-sm mb-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2">
          <li className="inline-flex items-center">
            <Link
              to="/"
              className="inline-flex items-center hover:text-blue-600 font-medium"
            >
              <HomeIcon className="w-4 h-4 mr-2 text-gray-400" />
              Trang chủ
            </Link>
          </li>

          <li>
            <div className="flex items-center">
              <svg
                className="w-3 h-3 mx-2 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              Thông báo
            </div>
          </li>

          <li>
            <div className="flex items-center">
              <svg
                className="w-3 h-3 mx-2 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>

              <span className="ml-1 text-gray-400 font-medium">
                {article?.title}
              </span>
            </div>
          </li>
        </ol>
      </nav>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mt-3 mb-2">
        <div className="md:col-span-8 col-span-12 overflow-auto">
          <h1 className="text-3xl font-bold mb-4">{article?.title}</h1>

          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-gray-600 mb-6 text-sm">
            <div>
              Ngày đăng:{" "}
              <span className="font-medium">
                {formatDate(article?.createdAt)}
              </span>
            </div>

            <span className="hidden sm:inline-block h-4 w-px bg-gray-300" />

            <div>
              Thời gian đăng ký:{" "}
              <span className="font-medium">
                {formatDate(article?.regisStartTime)} đến{" "}
                {formatDate(article?.regisEndTime)}
              </span>
            </div>

            <span className="hidden sm:inline-block h-4 w-px bg-gray-300" />

            <div>
              Ngày diễn ra:{" "}
              <span className="font-medium">
                {formatDate(article?.eventStartTime)}
              </span>
            </div>
          </div>

          <div className="flow-root">
            <div className="sun-editor-editable">
              <div
                className="prose max-w-none"
                dangerouslySetInnerHTML={{ __html: article?.content }}
              />
            </div>
          </div>

          <div className="mt-8 hidden">
            <h2 className="text-2xl font-semibold mb-4">Góp ý</h2>

            {comments.length > 0 ? (
              <div className="space-y-4">
                {comments.map((comment) => (
                  <div key={comment.id} className="bg-gray-100 p-4 rounded-lg">
                    <div className="flex items-center mb-2">
                      <span className="font-medium text-gray-800">
                        {comment.user?.userFullName || "Ẩn danh"}
                      </span>

                      <span className="text-gray-500 text-sm ml-2">
                        {new Date(comment.createdAt).toLocaleString("vi-VN")}
                      </span>
                    </div>

                    <p className="text-gray-700">{comment.content}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-500">Chưa có góp ý nào.</p>
            )}

            <form
              onSubmit={handleCommentSubmit}
              className="mt-6 bg-gray-50 p-4 rounded-lg"
            >
              <textarea
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                placeholder="Nhập góp ý của bạn..."
                className="w-full p-2 border rounded-md mb-4 min-h-[100px]"
                required
              />

              <button
                type="submit"
                disabled={commentLoading}
                className={`
                  px-4 py-2 rounded-md text-white font-semibold
                  ${
                    commentLoading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-500 hover:bg-blue-600"
                  }
                `}
              >
                {commentLoading ? "Đang gửi..." : "Gửi góp ý"}
              </button>
            </form>
          </div>
        </div>

        <div className="md:col-span-4 col-span-12">
          <div className={` top-0 "pt-0"}`}>
            {userId && !isGuestRegisCodeMatched && !loading && (
              <div className="my-2">
                <BusinessForm
                  noti={article}
                  isRegistedEvent={isRegistedEvent}
                  sendIsRegistedStatus={getRegisStatusFromBussinessForm}
                />
              </div>
            )}

            {isGuestRegisCodeMatched && !loading && (
              <div className="my-2 rounded-xl border border-blue-100 bg-blue-50 px-4 py-3 text-center text-sm font-medium text-blue-700">
                {guestTiming.lock
                  ? guestTiming.label
                  : isRegistedEvent
                    ? "Đã đăng ký tham gia"
                    : "Vui lòng hoàn tất form đăng ký tham gia sự kiện"}
              </div>
            )}

            {!userId && !isGuestRegisCodeMatched && !loading && (
              <div className="my-2 rounded-xl border border-dashed border-gray-300 px-4 py-3 text-center text-sm text-gray-500">
                Vui lòng đăng nhập để đăng ký tham gia sự kiện
              </div>
            )}

            <div className="my-4">
              {eventData ? (
                <button
                  onClick={handleOpenPdf}
                  className="w-full inline-flex items-center justify-center gap-2 rounded-xl border border-emerald-500 px-4 py-3 text-emerald-600 hover:bg-emerald-50 focus:outline-none focus:ring-2 focus:ring-emerald-300 active:scale-[0.99] transition"
                >
                  <svg
                    viewBox="0 0 24 24"
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path d="M19.5 14.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-10.5A2.25 2.25 0 0 0 4.5 6.75v10.5A2.25 2.25 0 0 0 6.75 19.5h6.75" />

                    <path d="M9 7.5h6M9 10.5h6M9 13.5h3" />

                    <path d="M16.5 19.5h4.5m-2.25 2.25V15" />
                  </svg>

                  <span className="font-semibold">XEM THIỆP MỜI</span>
                </button>
              ) : (
                <div className="w-full rounded-xl border border-dashed border-gray-300 px-4 py-3 text-center text-sm text-gray-500">
                  Thiệp mời đang cập nhật
                </div>
              )}
            </div>

            <div className="flex items-center justify-center">
              {isRegistedEvent && regisRollCallQRcode && (
                <div className="col pt-4 text-center">
                  {renderQrWithLogo(regisRollCallQRcode)}

                  <p className="text-gray-500 text-center pt-4">
                    Mã QR check-in
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <EventPDFModal
        isOpen={isOpenPdf}
        onClose={handleClosePdf}
        data={eventData}
      />

      {isOpenGuestRegis && (
        <div className="fixed inset-0 z-50 flex h-[100dvh] w-screen items-center justify-center overflow-hidden bg-black bg-opacity-40 px-3 py-3 sm:px-4 sm:py-6">
          <div className="flex max-h-full w-full max-w-lg flex-col overflow-hidden rounded-2xl bg-white shadow-xl">
            <div className="shrink-0 bg-gradient-to-r from-blue-50 to-cyan-50 px-4 py-4 border-b sm:px-6 sm:py-5">
              <div className="flex items-start justify-between gap-4">
                <div className="flex items-start gap-3">
                  <div className="w-11 h-11 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center shrink-0">
                    {guestRegisSuccess ? (
                      <CheckCircleIcon className="w-7 h-7" />
                    ) : (
                      <UserPlusIcon className="w-7 h-7" />
                    )}
                  </div>

                  <div>
                    <h2 className="text-lg font-bold text-gray-800">
                      {guestRegisSuccess
                        ? "Đăng ký sự kiện thành công"
                        : "Đăng ký tham gia sự kiện"}
                    </h2>

                    <p className="text-sm text-gray-700 mt-1 font-bold">
                      {article?.title}
                    </p>
                  </div>
                </div>

                {!guestRegisSuccess && !isGuestRegisCodeMatched && (
                  <button
                    onClick={handleCloseGuestRegis}
                    className="w-8 h-8 rounded-full flex items-center justify-center text-gray-500 hover:bg-white hover:text-gray-700 transition"
                  >
                    <XMarkIcon className="w-5 h-5" />
                  </button>
                )}
              </div>
            </div>

            <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain p-4 sm:p-6">
              {guestRegisSuccess ? (
                <div className="text-center">
                  <CheckCircleIcon className="w-16 h-16 text-green-500 mx-auto mb-3" />

                  <p className="text-gray-600 mb-5">
                    Bạn đã đăng ký sự kiện thành công. Mã QR đã được tự động tải
                    xuống, vui lòng mang theo mã QR này để check-in khi tham gia
                    sự kiện.
                  </p>

                  {regisRollCallQRcode && (
                    <div
                      ref={guestQrRef}
                      className="inline-block bg-white p-4 rounded-xl border"
                    >
                      {renderQrWithLogo(regisRollCallQRcode)}
                    </div>
                  )}

                  <div className="mt-6 flex flex-col sm:flex-row justify-center gap-2">
                    <button
                      type="button"
                      onClick={handleCloseGuestRegis}
                      className="btn rounded w-full sm:w-32"
                    >
                      Đóng
                    </button>

                    <button
                      type="button"
                      onClick={() => handleDownloadGuestQr(false)}
                      className="btn btn-primary rounded w-full sm:w-40"
                    >
                      <ArrowDownTrayIcon className="w-5 h-5" />
                      Tải QR
                    </button>
                  </div>
                </div>
              ) : (
                <form
                  onSubmit={handleSubmitGuestRegis}
                  className="flex min-h-full flex-col"
                >
                  <div className="space-y-3 sm:space-y-4">
                    <div className="form-control">
                      <label className="text-sm mb-1">
                        Họ tên người tham gia<i className="text-red-600"> *</i>
                      </label>

                      <input
                        type="text"
                        name="fullName"
                        value={guestFormData.fullName}
                        onChange={handleGuestChange}
                        className="input input-bordered w-full"
                        placeholder="Nhập họ tên người tham gia"
                        autoComplete="name"
                      />

                      <p className="text-red-500 text-xs mt-1">
                        {guestErrors.fullName}
                      </p>
                    </div>

                    <div className="form-control">
                      <label className="text-sm mb-1">Tên đơn vị</label>

                      <input
                        type="text"
                        name="organizationName"
                        value={guestFormData.organizationName}
                        onChange={handleGuestChange}
                        className="input input-bordered w-full"
                        placeholder="Nhập tên đơn vị"
                      />

                      <p className="text-red-500 text-xs mt-1">
                        {guestErrors.organizationName}
                      </p>
                    </div>

                    <div className="form-control">
                      <label className="text-sm mb-1">
                        Địa chỉ Doanh nghiệp
                      </label>

                      <input
                        type="text"
                        name="businessAddress"
                        value={guestFormData.businessAddress}
                        onChange={handleGuestChange}
                        className="input input-bordered w-full"
                        placeholder="Nhập địa chỉ doanh nghiệp"
                      />

                      <p className="text-red-500 text-xs mt-1">
                        {guestErrors.businessAddress}
                      </p>
                    </div>

                    <div className="form-control">
                      <label className="text-sm mb-1">
                        Ngành nghề kinh doanh
                      </label>

                      <input
                        type="text"
                        name="businessField"
                        value={guestFormData.businessField}
                        onChange={handleGuestChange}
                        className="input input-bordered w-full"
                        placeholder="Nhập ngành nghề kinh doanh"
                      />

                      <p className="text-red-500 text-xs mt-1">
                        {guestErrors.businessField}
                      </p>
                    </div>

                    <div className="form-control">
                      <label className="text-sm mb-1">Email</label>

                      <input
                        type="email"
                        name="email"
                        value={guestFormData.email}
                        onChange={handleGuestChange}
                        className="input input-bordered w-full"
                        placeholder="Nhập email"
                        autoComplete="email"
                      />

                      <p className="text-red-500 text-xs mt-1">
                        {guestErrors.email}
                      </p>
                    </div>

                    <div className="form-control">
                      <label className="text-sm mb-1">
                        Số điện thoại<i className="text-red-600"> *</i>
                      </label>

                      <input
                        type="text"
                        name="phoneNumber"
                        value={guestFormData.phoneNumber}
                        onChange={handleGuestChange}
                        className="input input-bordered w-full"
                        placeholder="Nhập số điện thoại"
                        autoComplete="tel"
                        inputMode="tel"
                      />

                      <p className="text-red-500 text-xs mt-1">
                        {guestErrors.phoneNumber}
                      </p>
                    </div>

                    <div className="flex items-start gap-2 rounded-lg bg-blue-50 border border-blue-200 px-3 py-2 text-sm text-blue-700">
                      <QrCodeIcon className="w-5 h-5 shrink-0 mt-0.5" />

                      <span>
                        Sau khi đăng ký thành công, hệ thống sẽ tự tải và hiển thị
                        mã QR check-in cho sự kiện này.
                      </span>
                    </div>
                  </div>

                  <div className="sticky bottom-0 -mx-4 -mb-4 mt-4 flex flex-col gap-2 bg-white px-4 py-3 sm:static sm:m-0 sm:mt-5 sm:flex-row sm:justify-end sm:p-0">
                    {!isGuestRegisCodeMatched && (
                      <button
                        type="button"
                        onClick={handleCloseGuestRegis}
                        className="btn rounded w-full sm:w-auto"
                        disabled={guestLoading}
                      >
                        Hủy
                      </button>
                    )}

                    <button
                      type="submit"
                      className="btn btn-primary rounded w-full sm:w-auto"
                      disabled={guestLoading}
                    >
                      {guestLoading ? (
                        <span className="loading loading-spinner" />
                      ) : (
                        "Đăng ký"
                      )}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailNoti;